export default "__VITE_ASSET__DSZREBDf__"